import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import './index.css'
import { CHUNK_RELOAD_STORAGE_KEY } from './utils/lazyWithRetry'

/* Efter lyckad start: tillåt ny auto-reload om chunk fel igen (t.ex. ny deploy). */
try {
  sessionStorage.removeItem(CHUNK_RELOAD_STORAGE_KEY)
} catch {
  /* ignore */
}

/* Reserv om React/router kastar chunk-fel som unhandled rejection */
window.addEventListener('unhandledrejection', (event) => {
  const reason = event.reason
  const msg = reason instanceof Error ? reason.message : String(reason ?? '')
  if (
    msg.includes('Failed to fetch dynamically imported module') ||
    msg.includes('Importing a module script failed') ||
    msg.includes('Loading chunk') ||
    msg.includes('ChunkLoadError')
  ) {
    event.preventDefault()
    try {
      if (!sessionStorage.getItem(CHUNK_RELOAD_STORAGE_KEY)) {
        sessionStorage.setItem(CHUNK_RELOAD_STORAGE_KEY, '1')
        window.location.reload()
      } else {
        sessionStorage.removeItem(CHUNK_RELOAD_STORAGE_KEY)
      }
    } catch {
      /* ignore */
    }
  }
})

createRoot(document.getElementById('root')!).render(
  <App />
)